module.exports = __webpack_public_path__ + "static/media/accessControlBuilding_41.88cff8eb.png";